import React, { Component } from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitlePositionOptions extends Component {



    static contextType = GlobalContext;
    constructor(props) {
        super(props);

        this.state = {
            alignment: this.props.alignment,
            applyAlignment: false,
            row: this.props.row,
            applyRow: false
        };
    }

    componentDidUpdate(prevProps)
    {

        if ((prevProps.row != this.props.row) || (prevProps.alignment != this.props.alignment))
        {
            this.setState ({alignment: this.props.alignment, row: this.props.row})
        }

    }

    notifyChange = () => {
        if (this.props.onChange) {
            this.props.onChange({
                alignment: this.state.alignment,
                applyAlignment: this.state.applyAlignment,
                row: this.state.row,
                applyRow: this.state.applyRow
            });
        }
    };

    getValues ()
    {
            return {
                alignment: this.state.alignment,
                applyAlignment: this.state.applyAlignment,
                row: this.state.row,
                applyRow: this.state.applyRow
            };

    }
    setValue = (name, value) => {
        this.setState(
            { [name]: value },
            this.notifyChange
        );
    };

    renderRow(children) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    marginBottom: "14px"
                }}
            >
                {children}
            </div>
        );
    }

    render() {

        const tapply = this.context.language == "fr"?"Appliquer":"Apply";
        const tline = this.context.language == "fr"?"Ligne":"Line";


        const tleft = this.context.language == "fr"?"Gauche":"Left";
        const tcenter = this.context.language == "fr"?"Centré":"Center";
        const tright = this.context.language == "fr"?"Droite":"Right";
        const tfree = this.context.language == "fr"?"Libre":"Free";




        const comboStyle = {
            flex: 1,
            padding: "8px 10px",
            background: "#404040",
            color: "#ffffff",
            border: "1px solid #5b5b5b",
            borderRadius: "6px",
            fontSize: "12px",
            outline: "none"
        };

        const checkStyle = {
            display: "flex",
            alignItems: "center",
            color: "#dddddd",
            whiteSpace: "nowrap",
            cursor: "pointer",
            userSelect: "none",
            fontSize: "13px",
        };

        return (

            <div
                style={{
                    width: "98%",
                    background: "black",
                    border: "1px solid #555",
                    borderRadius: "10px",
                    padding: "16px",
                    boxSizing: "border-box",
                    fontFamily: "Segoe UI, sans-serif",
                    marginBottom: "5px",
                }}
            >

                {this.renderRow(
                    <>
                        <select
                            style={comboStyle}
                            value={this.state.alignment}
                            onChange={(e) => {
                                this.setValue("applyAlignment", true);
                                this.setValue("alignment", e.target.value)}}
                        >
                            <option value="left">{tleft}</option>
                            <option value="center">{tcenter}</option>
                            <option value="right">{tright}</option>
                            <option value="free">{tfree}</option>
                        </select>

                        <label style={checkStyle}>
                            <input
                                type="checkbox"
                                checked={this.state.applyAlignment}
                                onChange={(e) =>
                                    this.setValue("applyAlignment", e.target.checked)
                                }
                                style={{
                                    marginRight: 8,
                                    accentColor: "#4ea1ff"
                                }}
                            />
                            {tapply}
                        </label>
                    </>
                )}

                {this.renderRow(
                    <>
                        <select
                            style={comboStyle}
                            value={this.state.row}
                            onChange={(e) =>{
                                this.setValue("applyRow", true)
                                this.setValue("row", parseInt(e.target.value))}
                                
                            }
                        >
                            {
                                Array.from({ length: 23 }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        {tline} {i + 1}
                                    </option>
                                ))
                            }
                        </select>

                        <label style={checkStyle}>
                            <input
                                type="checkbox"
                                checked={this.state.applyRow}
                                onChange={(e) =>
                                    this.setValue("applyRow", e.target.checked)
                                }
                                style={{
                                    marginRight: 8,
                                    accentColor: "#4ea1ff"
                                }}
                            />
                            {tapply}
                        </label>

                    </>
                )}

            </div>
        );
    }
}

export default SubtitlePositionOptions;